import { isString } from './common';

const monthNames = ['January', 'February', 'March', 'April', 'May', 'June',
  'July', 'August', 'September', 'October', 'November', 'December',
];
const daysName = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

function _getPluralize(number, range) {
  return `${number} ${range}${number > 1 ? 's' : ''}`;
}

export function getShortDate(string) {
  if (!string) return '';
  const date = new Date(string);
  const month = (`0${date.getMonth() + 1}`).slice(-2);
  const day = (`0${date.getDate()}`).slice(-2);
  const year = date.getFullYear().toString();
  return `${month}/${day}/${year}`;
}

export function getFullDate(string) {
  if (!string) return '';
  const normDate = isString(string) ? string.replace(' ', 'T') : string;
  const date = new Date(normDate);
  const month = monthNames[date.getMonth()];
  const day = (`0${date.getDate()}`).slice(-2);
  const year = date.getFullYear();
  return `${month} ${day}, ${year}`;
}

export function getMonth(string) {
  const date = new Date(string);
  return monthNames[date.getMonth()];
}

export function getShortMonth(string) {
  if (!string) return '';
  const normDate = isString(string) ? string.replace(' ', 'T') : string;
  const date = new Date(normDate);
  return monthNames[date.getMonth()].substr(0, 3);
}

export function getDay(string) {
  if (!string) return '';
  const normDate = isString(string) ? string.replace(' ', 'T') : string;
  const date = new Date(normDate);
  return (`0${date.getDate()}`).slice(-2);
}
export function getMonthWithYear(string) {
  if (!string) return '';
  const normDate = isString(string) ? string.replace(' ', 'T') : string;
  const date = new Date(normDate);
  const month = monthNames[date.getMonth()].substr(0, 3);
  const year = date.getFullYear();
  return `${month} ${year}`;
}
// /**
//  * Get different between 2 dates, show humanized result
//  * @param start
//  * @param end
//  * @returns {*}
//  */
// export function _getDatesDiff(start, end) {
//   const s = DateTime.fromJSDate(new Date(start));
//   const e = DateTime.fromJSDate(new Date(end));
//   if (s > e) return '';
//   const diff = e.diff(s, ['years', 'days', 'hours', 'minutes', 'seconds']);
//   let res = '';
//   if (diff.years) res = `${_getPluralize(diff.years, 'year')} `;
//   if (diff.days) res += _getPluralize(diff.days, 'day');
//   else if (diff.hours) res = _getPluralize(diff.hours, 'hour');
//   else if (diff.minutes) res = _getPluralize(diff.minutes, 'minute');
//   else res = 'Few seconds';
//   return res;
// }

/**
 * Get different between 2 dates, show humanized result
 * @param start
 * @param end
 * @returns {*}
 */
export function getDatesDiff(start, end) {
  const s = new Date(start);
  const e = new Date(end);
  const diff = e - s;
  if (diff < 0) return '';
  const years = e.getFullYear() - s.getFullYear();
  const days = Math.floor(diff / (24 * 3600 * 1000)) - (years * 365);
  const hours = Math.floor(diff / (3600 * 1000)) - (days * 24);
  const minutes = Math.floor(diff / (60 * 1000)) - (hours * 60);
  const prefix = 'ago';
  let res = '';
  if (years || days > 30) res = getShortDate(s);
  else if (days) res += `${_getPluralize(days, 'day')} ${prefix}`;
  else if (hours) res = `${_getPluralize(hours, 'hour')} ${prefix}`;
  else if (minutes) res = `${_getPluralize(minutes, 'minute')} ${prefix}`;
  else res = `Few seconds ${prefix}`;
  return res;
}

export function isDatesInSameDay(d1, d2) {
  return d1.getFullYear() === d2.getFullYear()
    && d1.getMonth() === d2.getMonth()
    && d1.getDate() === d2.getDate();
}

export function getFullTime(string) {
  if (!string) return '';
  const date = string.toString();
  const arr = date.split(' ');
  const time = arr[4];
  const timeZone = arr[5];
  return `${time}, ${timeZone}`;
}

/**
 * Get more humanize date
 * Almost the same as `getFullDate` methods
 * but return 'today' and 'yesterday' for relevant dates
 * @param dateString
 * @returns {string}
 */
export function getHumanizedDate(dateString) {
  const today = new Date();
  const date = new Date(dateString);
  const dateInString = date.toDateString();
  if (today.toDateString() === dateInString) return 'today';
  const yesterday = new Date(today.setDate(today.getDate() - 1));
  if (yesterday.toDateString() === dateInString) return 'yesterday';
  return getFullDate(date);
}

export function getWeekDayName(dateString) {
  if (!dateString) return '';
  const date = dateString instanceof Date ? dateString : new Date(dateString);
  return daysName[date.getDay()];
}

/**
 * Get 12 hours time from date string
 * @param dateString
 * @returns {string}
 */
export function get12HoursTimeFromString(dateString) {
  try {
    const time = dateString.match(/\d\d:\d\d/);
    let parsedTime = time[0].split(':'); // eslint-disable-line prefer-const
    let hours = Number.parseInt(parsedTime[0], 10);
    const minutes = parsedTime[1];
    let dayPeriod = 'AM';
    if ((hours - 12) >= 0) {
      hours -= 12;
      dayPeriod = 'PM';
    }
    hours = hours === 0 ? 12 : hours;
    return `${hours}:${minutes} ${dayPeriod}`;
  } catch (error) {
    return '';
  }
}

export function getShortDateWithTime(dateString) {
  const date = getShortDate(dateString);
  const time = get12HoursTimeFromString(dateString);
  return `${date}, ${time}`;
}

/**
 * Get date as string and return this date as Date object in CST time
 * @param dateString
 * @returns {Date}
 */
export function getConvertedDateToCST(dateString) {
  const current = new Date(dateString);
  // timeZone 'PST' doesn't work for firefox
  const currentCst = new Date(current.toLocaleString('en-US', { timeZone: 'America/Chicago' }));
  const diff = current.getTime() - currentCst.getTime();
  return new Date(current.getTime() + diff);
}
